import { handleActions, combineActions } from 'redux-actions'
import types from './types'

const INITIAL_STATE = {
  isLoading: true,
  isUpdating: false,
  noticeProcessSteps: [],
}

const beginLoading = combineActions(types.LOAD_NOTICE_PROCESS_STEPS)

const stopLoading = combineActions(
  types.LOAD_NOTICE_PROCESS_STEPS_SUCCESS,
  types.LOAD_NOTICE_PROCESS_STEPS_FAIL,
  types.UPDATE_NOTICE_PROCESS_STEPS_SUCCESS,
  types.UPDATE_NOTICE_PROCESS_STEPS_FAIL
)

const reducer = handleActions(
  {
    [beginLoading]: (state) => ({
      ...state,
      isLoading: true,
    }),
    [stopLoading]: (state) => ({
      ...state,
      isLoading: false,
      isUpdating: false,
    }),
    [types.LOAD_NOTICE_PROCESS_STEPS_SUCCESS]: (
      state,
      {
        payload: {
          data: { data },
        },
      }
    ) => ({
      ...state,
      noticeProcessSteps: data,
      isLoading: false,
    }),
    [types.UPDATE_NOTICE_PROCESS_STEPS]: (state) => ({
      ...state,
      isUpdating: true,
    }),
    [types.UPDATE_NOTICE_PROCESS_STEPS_SUCCESS]: (
      state,
      {
        payload: {
          data: { data },
        },
      }
    ) => ({
      ...state,
      noticeProcessSteps: data,
      isLoading: false,
      isUpdating: false,
    }),
    [types.CLEAR_STATE]: () => {
      return { ...INITIAL_STATE }
    },
  },
  INITIAL_STATE
)

export default reducer
